import React, { useState, useEffect } from "react";
import api from "../../services/api";
import * as S from "./styles";
import { toast } from "react-toastify";

const ListDepartamento = ({ onChange, ...props }) => {
  const [valueValid, setValueValid] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [options, setOptions] = useState([]);
  const [listDepartamento, setListDepartamento] = useState([]);

  useEffect(() => getAllCategoryStoreType(), []);

  async function getAllCategoryStoreType() {
    setIsLoading(true);
    try {
      const response = await api.get(`/api/departamento`);

      if (
        response?.data &&
        (response.status === 201 || response.status === 200)
      ) {
        let listDepartamento = response?.data || [];

        if (listDepartamento.length != 0) {
          listDepartamento = [
            { id: 0, descricao: "Selecione...", ordem: 0 },
          ].concat(listDepartamento);
        }

        setListDepartamento(listDepartamento);

        const optionsResult = listDepartamento.map((currOption, index) => {
          return (
            <S.Option key={index} value={currOption.id}>
              {currOption.descricao}
            </S.Option>
          );
        });

        setOptions(optionsResult);
      } else if (!response) {
        toast.error(
          "Erro ao buscar as Departamento, tente novamente mais tarde!"
        );
      }
    } catch (err) {
      if (err?.response?.data?.message) {
        toast.error(err?.response?.data?.message);
      } else {
        toast.error(
          "Erro ao buscar as Departamento, tente novamente mais tarde!"
        );
      }
    } finally {
      setIsLoading(false);
    }
  }

  function getDepartamentoById(id) {
    let departamento = null;
    if (id !== 0) {
      listDepartamento.every(function (currDepartamento) {
        if (id === Number(currDepartamento.id)) {
          departamento = currDepartamento;
          return false;
        }
        return true;
      });
    }
    return departamento;
  }

  return isLoading ? (
    <></>
  ) : (
    <>
      <S.Label {...props}>{props.label}</S.Label>
      <S.Select
        {...props}
        valueValid={valueValid}
        onChange={(e) => {
          const id = Number(e.target.value);

          setValueValid(id !== 0);

          onChange(getDepartamentoById(id));
        }}
      >
        {options}
      </S.Select>
    </>
  );
};

export default ListDepartamento;
